/**
 * @file utils.ts
 * @summary Librairie utilitaire
 *
 * Fonctions pures et helpers métier — pas de dépendance React. Couverture par tests unitaires Vitest dans `src/test/`.
 *
 * @see docs/07-CODEBASE.md — conventions de code
 * @see docs/02-FRONTEND.md — design system (tokens HSL, typographie)
 */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
